/**
 * "Save changes to … before closing?" -- the nag before anything that would
 * discard unsaved work: closing the document, or opening another.
 */

interface Props {
  filename: string
  /** What happens after: shapes the wording. */
  then: 'close' | 'open'
  /** Saving will invalidate this many signatures. */
  signatures?: number
  busy?: boolean
  onSave: () => void
  onDiscard: () => void
  onCancel: () => void
}

export function SaveChangesDialog({ filename, then, signatures = 0, busy, onSave, onDiscard, onCancel }: Props) {
  return (
    <div className="modal" role="alertdialog" aria-modal="true" aria-labelledby="unsaved-title"
         onKeyDown={(e) => { if (e.key === 'Escape') onCancel() }}>
      <div className="modal__panel">
        <h2 className="modal__title" id="unsaved-title">Save changes?</h2>
        <div className="modal__body">
          <p>
            <strong>{filename}</strong> has changes that have not been saved.
            {then === 'close' ? ' Save them before closing?' : ' Save them before opening another file?'}
          </p>
          {signatures > 0 && (
            <p className="modal__hint modal__hint--warn">
              This document is signed. Saving your changes will invalidate its
              {signatures === 1 ? ' signature' : ` ${signatures} signatures`}.
            </p>
          )}
          <p className="modal__hint">If you don&rsquo;t save, your changes are lost.</p>
        </div>
        <div className="modal__footer">
          <button className="btn" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="btn btn--danger" onClick={onDiscard} disabled={busy}>Don&rsquo;t save</button>
          <button className="btn btn--primary" onClick={onSave} disabled={busy} autoFocus>
            {busy ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  )
}
